<template>
  <Breadcrumbs title="Edit Profile" main="Users" />
  <div class="container-fluid">
    <div class="edit-profile">
      <div class="row">
        <!-- <sidePage /> -->
        <div class="col-xl-4">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title mb-0">ช่างภาพ</h4>
              <div class="card-options">
                <a
                  class="card-options-collapse"
                  href="javascript:void(0)"
                  data-bs-toggle="card-collapse"
                  ><i class="fe fe-chevron-up"></i></a
                ><a
                  class="card-options-remove"
                  href="javascript:void(0)"
                  data-bs-toggle="card-remove"
                  ><i class="fe fe-x"></i
                ></a>
              </div>
            </div>
            <div class="card-body">
              <form @submit.prevent="updatePassword">
                <div class="row mb-2">
                  <div class="profile-title">
                    <div class="media">
                      
                      <img width="100" 
                        class="img-70 rounded-circle"
                        src="@/assets/images/running/running-logo-s.jpg"
                        alt="profile"
                      />
                      <div class="media-body">
                        <div v-if="this.user">
                          <div class="profile-name-row">
                            <h5 class="mb-1 mt-1">
                              {{ this.name }}
                              {{ this.sername }}
                            </h5>
                            <span
                              v-if="this.user.is_verify_account === 'Y'"
                              class="verified-badge"
                              title="Verified"
                            >
                              <span class="verified-badge-icon">✓</span>
                              <span class="verified-badge-text">Verified</span>
                            </span>
                          </div>
                        </div>
                        <p v-if="this.role_name">
                          {{ this.role_name }}
                        </p>
                        <p v-if="!this.role_name">photographer</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label">หมายเลขช่างภาพ</label>
                  <input class="form-control" v-model="this.user_id_text" disabled />
                </div>
                <div class="mb-3">
                  <label class="form-label">Email-Address</label>
                  <input
                    class="form-control"
                    v-model="this.email"
                    disabled="your-email@domain.com"
                  />
                </div>

                <div class="mb-3">
                  <label class="form-label">รหัสผ่าน</label>
                  <input
                    class="form-control"
                    v-model="this.password"
                    type="password"
                  />
                </div>
                <div class="mb-3">
                  <label class="form-label">ยืนยันรหัสผ่าน</label>
                  <input
                    class="form-control"
                    v-model="this.confirm_password"
                    type="password"
                  />
                </div>
                <div class="form-footer">
                  <button type="submit" class="btn btn-primary btn-block">
                    อัปเดตรหัสผ่าน
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- <editProfile /> -->
        <div class="col-xl-8">
          <form class="card" @submit.prevent="updateProfileV3">
            <div class="card-header card-header-with-action">
              <h4 class="card-title mb-0">แก้ไขข้อมูลช่างภาพ</h4>
              <div class="card-header-action-group">
                <button class="btn btn-primary btn-sm top-update-btn" type="submit">
                  Update Profile
                </button>
                <div class="card-options">
                  <a
                    class="card-options-collapse"
                    href="javascript:void(0)"
                    data-bs-toggle="card-collapse"
                    ><i class="fe fe-chevron-up"></i></a
                  ><a
                    class="card-options-remove"
                    href="javascript:void(0)"
                    data-bs-toggle="card-remove"
                    ><i class="fe fe-x"></i
                  ></a>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label">ช่างภาพ/ชื่อที่แสดง/ชื่อเพจ</label>
                    <input
                      class="form-control"
                      v-model="this.display_name"
                      type="text"
                      maxlength="15"
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-4">
                  <div class="mb-3">
                    <label class="form-label">โทรศัพท์</label>
                    <input
                      class="form-control"
                      v-model="this.mobile_no"
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      @input="onMobileNoInput"
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="mb-3">
                    <label class="form-label">Line ID</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="this.line_id"
                    />
                  </div>
                </div>

                <div class="col-sm-6 col-md-6">
                  <div class="mb-3">
                    <label class="form-label">ชื่อ</label>
                    <input
                      class="form-control"
                      v-model="this.name"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="mb-3">
                    <label class="form-label">นามสกุล</label>
                    <input
                      class="form-control"
                      v-model="this.sername"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">ที่อยู่พักอาศัย</label>
                    <small class="text-muted d-block mb-2">
                      อยู่แถวไหน โซนๆ ไหน เพื่อให้เราสามารถติดต่อคุณได้สะดวกมากขึ้น
                    </small>
                    <input
                      class="form-control"
                      v-model="this.address"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label">จังหวัดที่พักอาศัย</label>
                    <select class="form-select" v-model="this.province">
                      <option value="">กรุณาเลือกจังหวัด</option>
                      <option
                        v-for="provinceName in this.thai_provinces"
                        :key="provinceName"
                        :value="provinceName"
                      >
                        {{ provinceName }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="mb-3">
                    <label class="form-label">แฟนเพจ URL เพื่อให้เราติดตามผลงานคุณ</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="this.fanpage_url"
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div>
                    <label class="form-label">เกี่ยวกับฉัน</label>
                    <small class="text-muted d-block mb-2">
                      อุปกรณ์ (เช่น กล้อง เลนส์ อื่นๆ รุ่นอะไร) ประสบการณ์การถ่ายภาพ สไตล์การถ่ายภาพที่ชอบ หรือข้อมูลอื่นๆ ที่อยากให้เรารู้จักคุณมากขึ้น
                    </small>
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="this.about_me"
                      placeholder="อุปกรณ์ (เช่น กล้อง เลนส์ อื่นๆ รุ่นอะไร) ประสบการณ์การถ่ายภาพ สไตล์การถ่ายภาพที่ชอบ หรือข้อมูลอื่นๆ ที่อยากให้เรารู้จักคุณมากขึ้น"
                    ></textarea>
                  </div>
                </div>

                <p>&nbsp;</p>

                <p>&nbsp;</p>

                <div class="col-md-6">
                  <div class="document-card mb-3">
                    <div class="document-card-header">
                      <div>
                        <p class="document-card-eyebrow mb-1">เอกสารยืนยันบัญชี</p>
                        <label class="form-label document-card-title mb-0">แนบหน้าสมุดบัญชีธนาคาร</label>
                      </div>
                      <span class="document-status" :class="this.bank_book_url ? 'is-ready' : 'is-empty'">
                        {{ this.bank_book_url ? 'มีไฟล์ในระบบแล้ว' : 'ยังไม่มีไฟล์แนบ' }}
                      </span>
                    </div>
                    <div class="mb-3">
                      <label class="form-label">ชื่อบัญชี (<span style="color: red;">ตรงกับหน้าสมุดบัญชี</span>)</label>
                      <input
                        class="form-control"
                        v-model="this.bank_account_name"
                      />
                    </div>
                    <div class="mb-3">
                      <label class="form-label">เลขที่บัญชี (<span style="color: red;">ตัวเลขเท่านั้น</span>)</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="this.bank_account_no"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        @input="onBankAccountNoInput"
                      />
                    </div>
                    <div class="mb-3">
                      <label class="form-label">ธนาคาร</label>
                      <select class="form-select" required v-model="bank_name" id="bank_name">
                        <option value="" disabled selected>กรุณาเลือกธนาคาร</option>
                        <option value="กรุงเทพ">ธนาคารกรุงเทพ (BBL)</option>
                        <option value="กสิกรไทย">ธนาคารกสิกรไทย (KBANK)</option>
                        <option value="กรุงไทย">ธนาคารกรุงไทย (KTB)</option>
                        <option value="ไทยพาณิชย์">ธนาคารไทยพาณิชย์ (SCB)</option>
                        <option value="กรุงศรีอยุธยา">ธนาคารกรุงศรีอยุธยา (BAY)</option>
                        <option value="ทหารไทยธนชาต">ธนาคารทหารไทยธนชาต (ttb)</option>
                        <option value="ยูโอบี">ธนาคารยูโอบี (UOB)</option>
                        <option value="ออมสิน">ธนาคารออมสิน (GSB)</option>
                        <option value="เพื่อการเกษตรและสหกรณ์การเกษตร">ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (BAAC)</option>
                        <option value="อาคารสงเคราะห์">ธนาคารอาคารสงเคราะห์ (GHB)</option>
                        <option value="อิสลามแห่งประเทศไทย">ธนาคารอิสลามแห่งประเทศไทย (ibank)</option>
                        <option value="เกียรตินาคินภัทร">ธนาคารเกียรตินาคินภัทร (KKP)</option>
                        <option value="ทิสโก้">ธนาคารทิสโก้ (TISCO)</option>
                        <option value="ซีไอเอ็มบี ไทย">ธนาคารซีไอเอ็มบี ไทย (CIMBT)</option>
                        <option value="แลนด์ แอนด์ เฮ้าส์">ธนาคารแลนด์ แอนด์ เฮ้าส์ (LHBANK)</option>
                        <option value="ไทยเครดิต">ธนาคารไทยเครดิต (Thai Credit)</option>
                        <option value="ไอซีบีซี">ธนาคารไอซีบีซี (ไทย) (ICBC)</option>
                      </select>
                    </div>
                    <div class="document-preview mb-3">
                      <div class="document-preview-header">
                        <span>ไฟล์ปัจจุบันบนระบบ</span>
                      </div>
                      <div v-if="this.bank_book_url" class="document-preview-body">
                        <img
                          :src="withCacheBust(this.bank_book_url)"
                          alt="bank account document"
                          class="document-preview-image"
                        />
                      </div>
                      <div v-else class="document-empty-state">
                        <small class="text-muted document-empty-label">ยังไม่มีไฟล์แนบในระบบ</small>
                      </div>
                    </div>
                    <div class="document-upload-box">
                      <input
                        class="form-control"
                        type="file"
                        accept="image/*"
                        @change="onFileChange($event, 'bankBook')"
                      />
                      <small class="text-muted d-block mt-2">
                        รองรับไฟล์รูปภาพเท่านั้น ขนาดไม่เกิน 3 MB
                      </small>
                      <div v-if="this.bank_book_file_name" class="selected-file-pill mt-2">
                        ไฟล์ที่เลือก: {{ this.bank_book_file_name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="document-card mb-3">
                    <div class="document-card-header">
                      <div>
                        <p class="document-card-eyebrow mb-1">เอกสารยืนยันตัวตน</p>
                        <label class="form-label document-card-title mb-0">แนบบัตรประชาชน</label>
                      </div>
                      <span class="document-status" :class="this.citizen_card_url ? 'is-ready' : 'is-empty'">
                        {{ this.citizen_card_url ? 'มีไฟล์ในระบบแล้ว' : 'ยังไม่มีไฟล์แนบ' }}
                      </span>
                    </div>
                    <div class="mb-3">
                      <label class="form-label">เลขที่บัตรประชาชน (<span style="color: red;">ตัวเลขเท่านั้น</span>)</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="this.id_card"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        maxlength="13"
                        @input="onIdCardNoInput"
                        placeholder="กรอกเลขบัตรประชาชน"
                      />
                    </div>
                    <small style="color: red;" class="d-block mt-2">
                        * กรุณาแนบสำเนาบัตรประชาชนพร้อมเซ็นสำเนาถูกต้อง
                        และเซ็นกำกับว่า "ใช้สำหรับรับเงินถ่ายภาพและวีดีโอเท่านั้น"
                      </small>
                    <div class="document-preview mb-3">
                      <div class="document-preview-header">
                        <span>ไฟล์ปัจจุบันบนระบบ</span>
                      </div>
                      <div v-if="this.citizen_card_url" class="document-preview-body">
                        <img
                          :src="withCacheBust(this.citizen_card_url)"
                          alt="id card document"
                          class="document-preview-image"
                        />
                      </div>
                      <div v-else class="document-empty-state">
                        <small class="text-muted document-empty-label">ยังไม่มีไฟล์แนบในระบบ</small>
                      </div>
                    </div>
                    
                    <div class="document-upload-box">
                      <input
                        class="form-control"
                        type="file"
                        accept="image/*"
                        @change="onFileChange($event, 'citizenCard')"
                      />
                       
                      <small class="text-muted d-block mt-2">
                        รองรับไฟล์รูปภาพเท่านั้น ขนาดไม่เกิน 3 MB
                      </small>
                     
                      <div
                        v-if="this.citizen_card_file_name"
                        class="selected-file-pill mt-2"
                      >
                        ไฟล์ที่เลือก: {{ this.citizen_card_file_name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer text-end">
              <button class="btn btn-primary" type="submit">
                Update Profile
              </button>

              <!-- <button class="btn btn-secondary" type="reset">Cancel</button> -->
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.btn {
  transition: all 0.3s ease;
  border-radius: 0.5rem;
  font-weight: 500;
}

.btn-primary {
  background: linear-gradient(135deg, #33adf3 0%, #ab7dda 100%);
  border: none;
}

.card-header-with-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.card-header-action-group {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.top-update-btn {
  white-space: nowrap;
}

.profile-name-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.verified-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.15rem 0.5rem 0.15rem 0.15rem;
  border-radius: 999px;
  background-color: rgba(24, 119, 242, 0.08);
}

.verified-badge-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #4cb5ff 0%, #1877f2 100%);
  color: #ffffff;
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1;
}

.verified-badge-text {
  color: #1877f2;
  font-size: 0.74rem;
  font-weight: 600;
  line-height: 1;
}

.document-card {
  height: 100%;
  padding: 1rem;
  border: 1px solid #e7edf3;
  border-radius: 1rem;
  background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  box-shadow: 0 12px 30px rgba(31, 70, 144, 0.08);
}

.document-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.document-card-eyebrow {
  color: #7c8aa5;
  font-size: 0.78rem;
  letter-spacing: 0.04em;
}

.document-card-title {
  color: #20304a;
  font-size: 1rem;
  font-weight: 600;
}

.document-status {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
}

.document-status.is-ready {
  color: #0d8a61;
  background-color: #e7f8f1;
}

.document-status.is-empty {
  color: #9a6b00;
  background-color: #fff5db;
}

.document-upload-box {
  padding: 0.85rem;
  border-radius: 0.85rem;
  background-color: rgba(255, 255, 255, 0.88);
  border: 1px solid #edf2f7;
}

.selected-file-pill {
  display: inline-flex;
  max-width: 100%;
  padding: 0.45rem 0.75rem;
  border-radius: 999px;
  color: #157257;
  background-color: #e9fbf5;
  font-size: 0.82rem;
  font-weight: 500;
  word-break: break-word;
}

.document-preview {
  overflow: hidden;
  border: 1px dashed #cfe0f3;
  border-radius: 0.9rem;
  background-color: #f8fbff;
}

.document-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #35507a;
  background: linear-gradient(90deg, rgba(51, 173, 243, 0.12) 0%, rgba(171, 125, 218, 0.08) 100%);
}

.document-preview-body {
  padding: 1rem;
}

.document-preview-image {
  display: block;
  width: 100%;
  max-height: 240px;
  object-fit: contain;
  border-radius: 0.5rem;
  background-color: #ffffff;
  border: 1px solid #edf2f7;
}

.document-empty-state {
  min-height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.5rem;
}

.document-empty-label {
  font-size: 0.86rem;
}

:deep(.swal2-popup.swal-success-popup) {
  border-radius: 14px;
}

:deep(.swal2-confirm.swal-success-button) {
  border-radius: 8px;
  padding: 0.5rem 1.25rem;
  font-weight: 600;
}
</style>
<script>

import axios from "axios";
import Swal from "sweetalert2";


export default {
  name: "UserEdit",
  components: {},
  setup() {},
  data() {
    return {
      user: null,
      user_id_text: "",
      user_id: "",
      name: "",
      sername: "",
      role_name: "",
      email: "",
      display_name: null,
      mobile_no: "",
      fanpage_url: "",
      address: "",
      sub_district: "",
      district: "",
      province: "",
      thai_provinces: [
        "กรุงเทพมหานคร",
        "กระบี่",
        "กาญจนบุรี",
        "กาฬสินธุ์",
        "กำแพงเพชร",
        "ขอนแก่น",
        "จันทบุรี",
        "ฉะเชิงเทรา",
        "ชลบุรี",
        "ชัยนาท",
        "ชัยภูมิ",
        "ชุมพร",
        "เชียงราย",
        "เชียงใหม่",
        "ตรัง",
        "ตราด",
        "ตาก",
        "นครนายก",
        "นครปฐม",
        "นครพนม",
        "นครราชสีมา",
        "นครศรีธรรมราช",
        "นครสวรรค์",
        "นนทบุรี",
        "นราธิวาส",
        "น่าน",
        "บึงกาฬ",
        "บุรีรัมย์",
        "ปทุมธานี",
        "ประจวบคีรีขันธ์",
        "ปราจีนบุรี",
        "ปัตตานี",
        "พระนครศรีอยุธยา",
        "พะเยา",
        "พังงา",
        "พัทลุง",
        "พิจิตร",
        "พิษณุโลก",
        "เพชรบุรี",
        "เพชรบูรณ์",
        "แพร่",
        "ภูเก็ต",
        "มหาสารคาม",
        "มุกดาหาร",
        "แม่ฮ่องสอน",
        "ยโสธร",
        "ยะลา",
        "ร้อยเอ็ด",
        "ระนอง",
        "ระยอง",
        "ราชบุรี",
        "ลพบุรี",
        "ลำปาง",
        "ลำพูน",
        "เลย",
        "ศรีสะเกษ",
        "สกลนคร",
        "สงขลา",
        "สตูล",
        "สมุทรปราการ",
        "สมุทรสงคราม",
        "สมุทรสาคร",
        "สระแก้ว",
        "สระบุรี",
        "สิงห์บุรี",
        "สุโขทัย",
        "สุพรรณบุรี",
        "สุราษฎร์ธานี",
        "สุรินทร์",
        "หนองคาย",
        "หนองบัวลำภู",
        "อ่างทอง",
        "อำนาจเจริญ",
        "อุดรธานี",
        "อุตรดิตถ์",
        "อุทัยธานี",
        "อุบลราชธานี"
      ],
      post_code: "",
      about_me: "",
      bank_account_name: "",
      bank_account_no: "",
      bank_name: "",
      line_id: "",
      id_card: "",
      bank_book_file: null,
      bank_book_file_name: "",
      bank_book_url: "",
      citizen_card_file: null,
      citizen_card_file_name: "",
      citizen_card_url: "",
      cache_bust_ts: Date.now(),
      password: "",
      confirm_password: "",
      token: localStorage.getItem("jwt"),
      system_prefix: process.env.VUE_APP_SYSTEM_PREFIX,
      aws_s3_bucket_url: process.env.VUE_APP_AWS_S3_URL,
      systemName: process.env.VUE_APP_SYSTEM_NAME,

    };
  },
  created() {
    this.getUser();
  },
  methods: {
    async getUser() {
      try {
        const headers = {
          'Authorization': 'Bearer ' + this.token
        };
        const responseUser = await axios.post("/v1/user/user", null, {
          headers
        });
        if (responseUser.data.status === "success") {
          this.user = JSON.parse(JSON.stringify(responseUser.data.body));

          this.user_id = this.user.user_id;
          this.user_id_text = this.system_prefix + this.user.user_id_text;

          this.name = this.user.name;
          this.sername = this.user.sername;
          this.role_name = this.user.role_name;

          this.email = this.user.email;
          this.display_name = this.user.display_name;
          this.mobile_no = this.user.mobile_no;
          this.fanpage_url = this.user.fanpage_url;
          this.address = this.user.address;
          this.sub_district = this.user.sub_district;
          this.district = this.user.district;
          this.province = this.user.province;
          this.post_code = this.user.post_code;
          this.about_me = this.user.about_me;
          this.bank_account_name = this.user.bank_account_name;
          this.bank_account_no = this.user.bank_account_no;
          this.bank_name = this.user.bank_name;
          this.line_id = this.user.line_id;
          this.id_card = this.user.id_card ;
          this.bank_book_url =
            this.user.bank_account_image_url ||
            this.user.bank_book_url ||
            this.user.bank_book_file_url ||
            this.user.bank_book_image_url ||
            "";
          this.citizen_card_url =
            this.user.id_card_image_url ||
            this.user.citizen_card_url ||
            this.user.citizen_card_file_url ||
            this.user.id_card_url ||
            this.user.identity_card_url ||
            "";
        } else {
          alert("พบข้อผิดพลาดกรุณา logout แล้ว login อีกครั้ง");
          //this.$router.push({ path: "/auth/login" });
        }
      } catch (error) {
        alert("พบข้อผิดพลาดกรุณา logout แล้ว login อีกครั้ง");
        //this.$router.push({ path: "/auth/login" });
      }
    },
    onMobileNoInput(event) {
      this.mobile_no = String(event.target.value || "").replace(/\D/g, "");
    },
    onBankAccountNoInput(event) {
      this.bank_account_no = String(event.target.value || "").replace(/\D/g, "");
    },
    onIdCardNoInput(event) {
      this.id_card = String(event.target.value || "").replace(/\D/g, "").slice(0, 13);
    },
    async showSuccessAlert(message = "บันทึกข้อมูลสำเร็จ") {
      await Swal.fire({
        icon: "success",
        title: "สำเร็จ",
        text: message,
        confirmButtonText: "ตกลง",
        confirmButtonColor: "#1877f2",
        customClass: {
          popup: "swal-success-popup",
          confirmButton: "swal-success-button"
        }
      });
    },
    withCacheBust(url) {
      if (!url) {
        return "";
      }

      const separator = url.includes("?") ? "&" : "?";
      return `${this.aws_s3_bucket_url}${url}${separator}t=${this.cache_bust_ts}`;
    },
    onFileChange(event, target) {
      const file = event.target.files && event.target.files[0];

      if (!file) {
        this.assignSelectedFile(target, null);
        return;
      }

      const maxFileSize = 3 * 1024 * 1024;
      const isImage = file.type.startsWith("image/");

      if (!isImage) {
        alert("กรุณาแนบไฟล์รูปภาพเท่านั้น");
        event.target.value = "";
        this.assignSelectedFile(target, null);
        return;
      }

      if (file.size > maxFileSize) {
        alert("ขนาดไฟล์ต้องไม่เกิน 3 MB");
        event.target.value = "";
        this.assignSelectedFile(target, null);
        return;
      }

      this.assignSelectedFile(target, file);
    },
    assignSelectedFile(target, file) {
      if (target === "bankBook") {
        this.bank_book_file = file;
        this.bank_book_file_name = file ? file.name : "";
        return;
      }

      if (target === "citizenCard") {
        this.citizen_card_file = file;
        this.citizen_card_file_name = file ? file.name : "";
      }
    },
    async validateProfileRequiredFields() {
      const missingFields = [];

      if (!String(this.bank_account_name || "").trim()) {
        missingFields.push("ชื่อบัญชี (ตรงกับหน้าสมุดบัญชี)");
      }

      if (!String(this.bank_account_no || "").trim()) {
        missingFields.push("เลขที่บัญชี (ตัวเลขเท่านั้น)");
      }

      if (!String(this.bank_name || "").trim()) {
        missingFields.push("ธนาคาร");
      }

      if (!String(this.id_card || "").trim()) {
        missingFields.push("เลขที่บัตรประชาชน");
      }

      if (missingFields.length === 0) {
        return true;
      }

      await Swal.fire({
        icon: "warning",
        title: "กรอกข้อมูลไม่ครบ",
        html: `กรุณากรอกข้อมูลต่อไปนี้<br>${missingFields.map((item) => `- ${item}`).join("<br>")}`,
        confirmButtonText: "ตกลง",
        confirmButtonColor: "#f0ad4e"
      });

      return false;
    },
    
    async updateProfileV3() {
      try {
        const isValid = await this.validateProfileRequiredFields();
        if (!isValid) {
          return false;
        }

        const data = new FormData();

        data.append("user_id", this.user_id || "");
        data.append("name", this.name || "");
        data.append("sername", this.sername || "");
        data.append("email", this.email || "");
        data.append("display_name", this.display_name || "");
        data.append("mobile_no", this.mobile_no || "");
        data.append("fanpage_url", this.fanpage_url || "");
        data.append("address", this.address || "");
        data.append("sub_district", this.sub_district || "");
        data.append("district", this.district || "");
        data.append("province", this.province || "");
        data.append("post_code", this.post_code || "");
        data.append("about_me", this.about_me || "");
        data.append("bank_account_name", this.bank_account_name || "");
        data.append("bank_account_no", this.bank_account_no || "");
        data.append("bank_name", this.bank_name || "");
        data.append("line_id", this.line_id || "");
        data.append("id_card", this.id_card || "");

        if (this.bank_book_file) {
          data.append("bank_book_file", this.bank_book_file);
        }

        if (this.citizen_card_file) {
          data.append("citizen_card_file", this.citizen_card_file);
        }

        const headers = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + this.token
        };
        const responseUser = await axios.post("/v2/user/user-update",data, {
          headers
        });
        const response = await axios.post(
          "v1/admin/dashboard-report-order-summery",
          data,
          {
            headers
          }
        );
        if (responseUser.data.status === "success") {
          await this.showSuccessAlert();
          //location.reload();
          this.getUser();
        } else {
          alert("[unauthorized] พบข้อผิดพลาด! กรุณา login แล้วลอง update ข้อมูลอีกครั้ง");
          return false;
        }
      } catch (error) {
        alert("พบข้อผิดพลาด! กรุณา login แล้วลอง update ข้อมูลอีกครั้ง: " + JSON.stringify(error));
        return false;
      }
    },
    async updatePassword() {
      try {

        if(this.password !== this.confirm_password){
          alert("password ไม่ตรงกัน!")

        }else if(this.password.length <8){
          alert("รหัสผ่านควรมีความยาว 8 ตัวอักษรขึ้นไป")
        }else{
          if(confirm("ยื่นยัน การตั้งรหัสเข้าใช้งานใหม่?")){
            let data = {
              password: this.password
            };
           // console.log("data:" + JSON.stringify(data));

           const headers = {
            'Authorization': 'Bearer ' + this.token
          };
            const responseUser = await axios.post("/v1/user/user-password-update",data, {
              headers
            });

            if (responseUser.data.status === "success") {
              await this.showSuccessAlert();
              //this.$router.push({ path: "/auth/login" });
              
            } else {
              alert("[unauthorized] พบข้อผิดพลาด! กรุณา login แล้วลอง update ข้อมูลอีกครั้ง");
              //this.$router.push({ path: "/auth/login" });
            } 
          }else{
            return false;
          }

        }
      } catch (error) {
        alert("พบข้อผิดพลาด! กรุณา login แล้วลอง update ข้อมูลอีกครั้ง");
        //this.$router.push({ path: "/auth/login" });
      }
    },
  },
  mounted() {},
};
</script>